import styled from 'styled-components';
import { theme } from '../../theme';
import { ScrollPosition } from './utils/constants';
const { text, sizes } = theme;
const { blue } = theme.colors.secondary;
const { grey } = theme.colors.neutral;
const { scrollbar } = theme.colors.system;
const fixedColumnShadow = `
  position: absolute;
  top: 0;
  bottom: -1px;
  width: 30px;
  content: "";
  pointer-events: none;
  box-sizing: border-box;
  transition: box-shadow .3s;
`;
const startFixedColumnShadow = `
  box-shadow: inset 10px 0 10px -8px rgb(0 0 0 / 25%);
`;
const endFixedColumnShadow = `
  box-shadow: inset -10px 0 10px -8px rgb(0 0 0 / 25%);
`;
export const TooltipContent = styled.div.withConfig({ displayName: "vui--TooltipContent", componentId: "vui--mk4i58" }) `display:flex;flex-direction:row;align-items:center;`;
export const Wrapper = styled.div.withConfig({ displayName: "vui--Wrapper", componentId: "vui--1u7sppu" }) `width:100%;overflow-x:${(props) => (props.scrollDisabled ? 'hidden' : 'auto')};overflow-y:hidden;position:relative;border-top:1px solid ${grey.dark};border-bottom:1px solid ${grey.dark};${({ showScrollbar }) => showScrollbar
    ? `
    scrollbar-width: auto;

    &::-webkit-scrollbar {
      margin-top: 10px;
      width: 6px;
      height: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: ${scrollbar.background}; 
    }
    
    &::-webkit-scrollbar-thumb {
      background: ${scrollbar.thumb};
      border-radius: 4px; 
    }
    `
    : ''} ${({ scrollDisabled, lastStartFixedColumnsIndex, firstEndFixedColumnsIndex, scrollPosition }) => scrollDisabled
    ? ''
    : `
    td:nth-child(${lastStartFixedColumnsIndex}):after,
    th:nth-child(${lastStartFixedColumnsIndex}):after {
      right: 0;
      transform: translate(100%);
      ${fixedColumnShadow};

      ${scrollPosition === ScrollPosition.middle || scrollPosition === ScrollPosition.end
        ? startFixedColumnShadow
        : ''};
    };

    td:nth-last-child(${firstEndFixedColumnsIndex}):after,
    th:nth-last-child(${firstEndFixedColumnsIndex}):after {
      left: 0;
      transform: translate(-100%);
      ${fixedColumnShadow};

      ${scrollPosition === ScrollPosition.start || scrollPosition === ScrollPosition.middle
        ? endFixedColumnShadow
        : ''};
    };
  `}`;
export const WrapperBordered = styled(Wrapper).withConfig({ displayName: "vui--WrapperBordered", componentId: "vui--nqtqxh" }) `border:1px solid ${grey.dark};border-radius:4px;`;
export const Head = styled.thead.withConfig({ displayName: "vui--Head", componentId: "vui--hwzh6q" }) `background-color:white;`;
export const Body = styled.tbody.withConfig({ displayName: "vui--Body", componentId: "vui--1gnu0g8" }) `tr{${({ fixedColumnsStyle }) => fixedColumnsStyle};}& + & > tr:first-child > td{border-top:1px solid ${grey.base};}tr:not(:first-child)> td{border-top:1px solid transparent;}&&& tr:hover td{background-color:#ebf4fb;}`;
export const Foot = styled.tfoot.withConfig({ displayName: "vui--Foot", componentId: "vui--12mqlfu" }) `& td{background-color:${grey.lightest};padding:1.5rem 1rem;border-top:1px solid ${blue.base};}`;
export const Row = styled.tr.withConfig({ displayName: "vui--Row", componentId: "vui--r2keiy" }) `&.hidden{visibility:collapse;}${({ accentColor }) => accentColor &&
    `
    & > td:first-child::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 4px;
      background-color: ${accentColor};  
    }
  `}`;
export const Cell = styled.td.withConfig({ displayName: "vui--Cell", componentId: "vui--1nm3hyy" }) `position:relative;padding:1.25rem 1rem;text-align:${({ align }) => align || 'left'};background-color:white;font-family:${text.bodySmall.fontFamily};font-size:${text.bodySmall.fontSize};font-weight:${text.bodySmall.fontWeight};color:${text.bodySmall.color};line-height:${sizes.base};width:${({ grow }) => (grow ? '100%' : 'auto')};& > *{vertical-align:middle;}`;
export const HeaderCell = styled(Cell).attrs({
    as: 'th',
}).withConfig({ displayName: "vui--HeaderCell", componentId: "vui--kltvmt" }) `user-select:none;border-bottom:1px solid ${grey.dark};font-family:${text.bodySmallBold.fontFamily};font-size:${text.bodySmallBold.fontSize};font-weight:${text.bodySmallBold.fontWeight};color:${text.bodySmallBold.color};& span{white-space:pre-line;}&.sortable:hover{cursor:pointer;background-color:${grey.light};}`;
const alignmentMap = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
};
export const HeaderCellLayout = styled.div.withConfig({ displayName: "vui--HeaderCellLayout", componentId: "vui--12khvw8" }) `display:flex;align-items:center;justify-content:${({ align }) => (align ? alignmentMap[align] : 'flex-start')};& > * + *{margin-left:0.25rem;}`;
export const Table = styled.table.withConfig({ displayName: "vui--Table", componentId: "vui--h02j5" }) `width:100%;border-spacing:0;table-layout:${({ isFixedLayout }) => (isFixedLayout ? 'fixed' : 'auto')};${({ striped }) => striped &&
    `
    & ${Body}:nth-child(even) td {
      background-color: ${grey.lightest};
    }
  `} & *{box-sizing:border-box;${({ tableLoading }) => tableLoading &&
    `
      user-select: none;
      pointer-events: none;
    `}}${({ noWrap }) => noWrap &&
    `
    & ${HeaderCell}, & ${HeaderCell} span {
      white-space: nowrap;
    }
  `}`;
export const Footer = styled.tfoot.withConfig({ displayName: "vui--Footer", componentId: "vui--qgln4m" }) `tr{${({ fixedColumnsStyle }) => fixedColumnsStyle};}& ${Cell}{border-top:1px solid ${grey.dark};background-color:${grey.lightest};padding-top:${sizes.base};padding-bottom:${sizes.base};line-height:2rem;}`;
export const StickyHeaderWrapper = styled.div.withConfig({ displayName: "vui--StickyHeaderWrapper", componentId: "vui--12fomsb" }) `position:fixed;top:0;z-index:2;overflow-x:hidden;`;
export const FakeHeaderTable = styled(Table).withConfig({ displayName: "vui--FakeHeaderTable", componentId: "vui--1als2zg" }) ``;
//# sourceMappingURL=styled.js.map